import { CheckCircleIcon, InfoIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    List,
    ListIcon,
    ListItem,
    Modal,
    ModalBody, ModalCloseButton,
    ModalContent, ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure
} from '@chakra-ui/react';

const SignatureInfoModal = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <Button onClick={onOpen} leftIcon={<InfoIcon />} size="sm" variant="link" colorScheme="blue">
                How Signature Works
            </Button>

            <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>How Digital Signature Works</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <Box mb={4}>
                            <Text>
                                Our platform provides a secure and convenient way for physicians to sign digitally:
                            </Text>
                        </Box>

                        <List spacing={3}>
                            <ListItem>
                                <ListIcon as={CheckCircleIcon} color="green.500" />
                                After entering the physician's phone number, a secure signing link will be sent via SMS.
                            </ListItem>
                            <ListItem>
                                <ListIcon as={CheckCircleIcon} color="green.500" />
                                The link opens a secure page where the physician can review and sign.
                            </ListItem>
                            <ListItem>
                                <ListIcon as={CheckCircleIcon} color="green.500" />
                                Once signed, the digital signature is saved and linked to the physician’s profile.
                            </ListItem>
                            <ListItem>
                                <ListIcon as={CheckCircleIcon} color="green.500" />
                                No downloads or app installations are needed.
                            </ListItem>
                        </List>

                        <Box mt={4}>
                            <Text fontSize="sm" color="gray.600">
                                The signature process is encrypted and HIPAA-compliant.
                            </Text>
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default SignatureInfoModal;
